define([
	"csi/def/ActionFactory",
	"csi/widget/MessageDialog",
	"./Purge"
], function(ActionFactory,MessageDialog,Purge) {

	return ActionFactory.declare("PurgeRevisions", Purge, {
		m_tag: "PurgeRevisions",
		confirmAction: MessageDialog.BUTTON_PURGE
	});
});